/**
 * Is Nexus Dex itself in front? (2026-09-30 Galaxy run: while the trainer
 * was in our app the scanner read our own My Pokémon record page as "Lugia
 * CP 2607" and pushed it to the HUD.)
 *
 * `document.visibilityState` is useless for this on Android: the WebView
 * lives in a keep-alive overlay window during a scan and reports "visible"
 * with Pokémon GO in front. Capacitor's appStateChange follows the activity
 * (onResume / onPause), which is the question being asked. Installed once,
 * on first use; assumed active until the first event says otherwise.
 */
let active = true;
let installed = false;

export function isAppActive(): boolean {
  return active;
}

export function installAppActiveTracker(): void {
  if (installed) return;
  installed = true;
  void (async () => {
    try {
      const mod = await import("@capacitor/app" as any);
      const App = (mod as any).App;
      if (!App || typeof App.addListener !== "function") return;
      await App.addListener("appStateChange", (state: { isActive?: boolean }) => {
        active = state?.isActive !== false;
      });
    } catch {
      /* web / no plugin: stays active, the gate never fires */
    }
  })();
}

/** Test seam. */
export function __setAppActiveForTests(v: boolean): void {
  active = v;
}
